import { nodeIdOf } from './graph/prepareShareholderGraph';

/**
 * Row props for the tables below the mini graph: pointer or keyboard focus on a row reports its
 * entry, for the graph to highlight that node; leaving the row reports null. No props without a
 * handler.
 *
 * @param {Object} entry - the row's entry (a graph node of the structure)
 * @param {Function} [onHoverRow] - (entry | null) => void
 * @returns {Object}
 */
export const linkedRowProps = (entry, onHoverRow) =>
  onHoverRow
    ? {
        onMouseEnter: () => onHoverRow(entry),
        onMouseLeave: () => onHoverRow(null),
        onFocus: () => onHoverRow(entry),
        onBlur: (event) => {
          if (!event.currentTarget.contains(event.relatedTarget)) onHoverRow(null);
        }
      }
    : {};

/**
 * React key of a table row: the entry's graph id, so same-named rows stay apart. An entry with
 * neither id nor member_id has no graph id (nodeIdOf would give "undefined" for all of them), so
 * it falls back to its name and position.
 *
 * @param {Object} entry - the row's entry (a graph node of the structure)
 * @param {number} index - the row's position in its table
 * @returns {string}
 */
export const rowKeyOf = (entry, index) =>
  (entry.id ?? entry.member_id) == null ? `${entry.member_name}-${index}` : nodeIdOf(entry);
